import "../styles/css/bootstrap.min.css";
import Servicedata from "./Servicedata";
import { useContext, useEffect, useState } from "react";
import PaysContext from "../contexts/payscontext";
import AdminpaysContxt from "../contexts/adminpayscontext";
import axios from "axios";
import Postformulaire from "./Postformulaire";
import Postformulairepays from "./Postformulairepays";
import { Link } from "react-router-dom";
import PutFormulairepays from "./PutFormulairepays";
import PutFormulaire from "./PutFormulaire";
import Toast from 'react-bootstrap/Toast'
import logo from '../assets/logo/logo.jpg'





export default function Adminpaysform() {

  //Declaration de variables pour récupérer la liste des pays 
  //eagrimet.online
  // const urlgetpays = "http://localhost:8000/eagrimetApi/pays/";
  const urlgetpays = "https://eagrimet.online/eagrimetApi/pays/";

  const [lstPays, setLstPays] = useState([]);
  const [choixpays, SetChoixpays] = useState("");

  const v1context = useContext(PaysContext); // recupere le pays définit par défaut dans le fichier de context
  const v2context = useContext(AdminpaysContxt); // recupère le statut de l'administrateur par défaut à false

  // Declaration de variable useState pour modifier les 2 contextes
  const [payscon, SetPayscon] = useState(v1context);
  const[adminpayscon, SetAdminpayscon] = useState(v2context)

  


  // function qui permet d'actualiser le choix du pays effectué par l'Admin
  function handle(e) {
    SetChoixpays(e.target.value);
    
  }


  //UseEffet qui met à jour le UseState du contexte et du statut de l'Admin A chaque fois le pays change
  useEffect(() => {
    console.log("toto", choixpays);
    SetPayscon(choixpays);
    SetAdminpayscon(false)
  }, [choixpays]);


  // UseEffect qui permet de récupérer la liste des pays par l'API
  useEffect(() => {
    // Declaration de la fonction fetch de la liste des pays
    const fetchPays = async () => {
      try {
        const response = await fetch(urlgetpays, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token f976960761d6c971c5be927bb45c4abfa1fcc352",
          },
        });
        if (!response.ok) {
          console.error("Error getting liste pays");
          return;
        }
        const result = await response.json();
        setLstPays(result);
      } catch {
        console.error("Error getting liste pays");
      }
    };
    // Trigger the fetch
    fetchPays();
  }, []);


  //const payscourant = PaysContext;
 // const adminpayscontext =  AdminpaysContxt
 const [btncreation, SetBtncreation] = useState(true)
 const [btnmodif, SetBtnmodif] = useState(false)

  const [adminpaysExist, SetAdminpaysExist] = useState(false);
  const [showloginform , SetShowloginform] = useState(true)
  const [lstadminpays, setlstAdminpays] = useState([]);
  const [page, setPage] = useState("")
  const [adminphone, setAdminphone] = useState("");
  const [adminpassword, setAdminpassword] = useState("");
  const [typebulletin, setTypebulletin] = useState("national");
  //eagrimet.online
  // const urlget = "http://localhost:8000/eagrimetApi/adminPays/";
  const urlget = "https://eagrimet.online/eagrimetApi/adminPays/";
  let axiosconfig = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Token f976960761d6c971c5be927bb45c4abfa1fcc352",
    },
  };
   
  const [showMsg, SetShowMsg] = useState(false);      
  const checkUserMessage ="Désolé, Utilisateur inexistant. Veuillez contacter l'Administrateur " 
  const toggleShowMsg = () => {SetShowMsg(false) } 
  const ouvreMsg = () => {SetShowMsg(true)}


  //fonction de gestion des boutons creation et modification
  function deconnecter(e){
    window.location.reload();
  }

  function handlecreation(e){
     SetBtncreation(true)
     SetBtnmodif(false)
     
  }

  function handlemodif(e){
    SetBtncreation(false)
    SetBtnmodif(true)
    
 }

  useEffect(() => {
    const fetchAdminpays = async () => {
      await axios
        .get(urlget, axiosconfig)
        .then((resultat) => {
          setlstAdminpays(resultat.data);
        })
        .catch((error) => {
          console.error(error);
        });
    };
    fetchAdminpays();
  }, []);

  // Verification si l'Admin pays existe
  function CheckAdminpays() {
        console.log("liste admin pays ", lstadminpays);
        let resultat ={}
         resultat = lstadminpays.find(
         (adminp) =>
            adminp.numerotelephone === adminphone &&
            adminp.motdepasse === adminpassword &&
            adminp.pays === choixpays &&
            adminp.actif === true &&
            adminp.profession != "Journaliste"
        );

        if (resultat === undefined ){
            SetAdminpaysExist(false)
            SetShowloginform(true)
            console.log("vide", adminpaysExist)
            // Utilisateur inexistant
            ouvreMsg();
            
        } 
        else{   
            SetShowloginform(false)         
            SetAdminpaysExist(true)
            console.log(typeof(resultat), adminpaysExist)
            
        }        
        
    } // Fin fonction vérification existence Admin pays


  return (
    <div>
      {showloginform && (
        <div className="row mx-auto p-2 col-md-6">
          <form id="form">
            <div className="d-flex flex-row-reverse">
              {showMsg && (
                <Toast show={showMsg} onClose={toggleShowMsg}>
                  <Toast.Header className="bg-success">
                    <img
                      src={logo}
                      className="rounded-circle"
                      height={30}
                      alt=""
                    />
                    <strong>&nbsp; eAgrimet</strong>
                  </Toast.Header>
                  <Toast.Body>{checkUserMessage} </Toast.Body>
                </Toast>
              )}
            </div>

            <div className="border border-success">
              <h3>
                <i className="bi bi-personbi bi-cloud-lightning-rain-fill"></i>{" "}
                SHMN{" "}
              </h3>

              <div className="row justify-content-center">
                <div className="mb-4 col-6">
                  <i className="bi bi-telephone-fill"></i>
                  <input
                    id="Telephone"
                    type="text"
                    placeholder="Telephone"
                    className="form-control"
                    required
                    onChange={(e) => setAdminphone(e.target.value)}
                  />
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="mb-4 col-6">
                  <i className="bi bi-key-fill"></i>
                  <input
                    id="motdepasse"
                    type="password"
                    placeholder="Mot de passe"
                    className="form-control"
                    required
                    onChange={(e) => setAdminpassword(e.target.value)}
                  />
                </div>

                <div className="row justify-content-center">
                  <div className="mb-4 col-6">
                    <label for="pays" className="form-label">
                      Pays
                    </label>
                    <select
                      id="pays"
                      onChange={(e) => handle(e)}
                      className="form-select form-control"
                    >
                      {lstPays.map((objpays) => {
                        return (
                          <option key={objpays.code} value={objpays.code}>
                            {objpays.pays}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="mb-4 col-6">
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="choixsaisie"
                      id="national"
                      value="national"
                      defaultChecked={true}                      
                      onChange={(e) => setTypebulletin(e.target.value)}
                    />
                    <label className="form-check-label" for="national">
                      National
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="choixsaisie"
                      id="local"
                      value="local"                      
                      onChange={(e) => setTypebulletin(e.target.value)}
                    />
                    <label className="form-check-label" for="local">
                      Local
                    </label>
                  </div>
                </div>
              </div>
              <div div className="row justify-content-end">
                <div className="mb-4 col-md-6 ">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={CheckAdminpays}
                  >
                    Connecter
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      )}
      {adminpaysExist && (
        <div className="row justify-content-start pt-3 border-bottom border-success">
          <button className="btn  col-2 mx-3" onClick={(e) => deconnecter(e)}>
            <i className="bi bi-house"></i> Logout
          </button>
          <button
            className="btn  col-2 mx-3"
            onClick={(e) => handlecreation(e)}
          >
            <i className="bi bi-database-add"></i> Creation
          </button>
          <button className="btn  col-2 " onClick={(e) => handlemodif(e)}>
            <i className="bi bi-arrow-down-up"></i> Mise à jour
          </button>
        </div>
      )}

      {typebulletin == 'national' &&
        (<PaysContext.Provider value={payscon}>
        <Postformulairepays
          adminExiste={adminpaysExist}
          modecreation={btncreation}
        />
        <PutFormulairepays adminExiste={adminpaysExist} modemodif={btnmodif} />
      </PaysContext.Provider>)
      }

      {typebulletin == 'local' &&
        (<PaysContext.Provider value={payscon}>
        <Postformulaire
          adminExiste={adminpaysExist}
          modecreation={btncreation}
        />
        <PutFormulaire adminExiste={adminpaysExist} modemodif={btnmodif} />
      </PaysContext.Provider>)
      }
    </div>
  );
}
